import { render, staticRenderFns } from "./LeaveCollabModal.vue?vue&type=template&id=069b59af&scoped=true&"
import script from "./LeaveCollabModal.vue?vue&type=script&lang=ts&"
export * from "./LeaveCollabModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "069b59af",
  null
  
)

export default component.exports